<template>
  <div style="height: 100%">
    <v-container>
      <v-card class="my-5 mx-2 elevation-10 pa-2">
        <v-card-title class="text-h5"> Cadastro </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="user.name"
                  :rules="[$rules.required]"
                  label="Nome Completo *"
                  required
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="user.telephone"
                  :rules="[$rules.required, $rules.phone]"
                  label="Telefone *"
                  :disabled="loading"
                  placeholder="(00) 12345-1234"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="user.genre"
                  :rules="[$rules.required]"
                  label="Gênero *"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="user.birth_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="birthDateFormatted"
                      label="Data de Nascimento"
                      readonly
                      :disabled="loading"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="user.birth_date"
                    no-title
                    scrollable
                    locale="pt-br"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancelar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(user.birth_date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-text-field
                  v-model="user.email"
                  :rules="[$rules.required, $rules.email]"
                  label="E-mail *"
                  required
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="user.password"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :rules="[$rules.required, $rules.passwordMin]"
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-1"
                  label="Senha *"
                  hint="No mínimo 8 caracteres"
                  @click:append="showPassword = !showPassword"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  :rules="[
                    $rules.required,
                    $rules.passwordMin,
                    $rules.equalPassword(() => user.password),
                  ]"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-1"
                  label="Confirmação de Senha *"
                  hint="No mínimo 8 caracteres"
                  @click:append="showPassword = !showPassword"
                  :disabled="loading"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-select
                  v-model="user.state"
                  item-text="name"
                  item-value="id"
                  :items="states"
                  :rules="[$rules.required]"
                  :loading="loadingState"
                  :disabled="disabledState"
                  label="Estado *"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-select
                  v-model="user.city_id"
                  item-text="name"
                  item-value="id"
                  :items="cities"
                  :rules="[$rules.required]"
                  :disabled="disabledCity"
                  label="Cidade *"
                  placeholder="Selecione primeiro o estado"
                />
              </v-col>
            </v-row>

            <v-checkbox
              v-model="checkbox"
              :rules="[(v) => !!v || 'Você deve aceitar para continuar']"
              label="Concordo com os termos de uso e política de privacidade (links abaixo)"
              required
              :disabled="loading"
            />
            <a
              color="blue lighten-5"
              text
              class="ma-3 text-decoration-none text-decoration-underline"
              small
              target="_blank"
              href="https://olhadela.digital/termos-de-uso.pdf"
            >
              Termos de Uso
            </a>
            <a
              color="blue lighten-5"
              text
              class="ma-3 text-decoration-none text-decoration-underline"
              small
              target="_blank"
              href="https://olhadela.digital/politica-de-privacidade.pdf"
            >
              Política de Privacidade
            </a>
            <v-alert
              v-model="emailalert"
              type="warning"
              transition="scale-transition"
              >Esse E-mail já está em uso</v-alert
            >
            <v-alert
              v-model="erroralert"
              type="error"
              transition="scale-transition"
            >
              Um erro inesperado aconteceu, contate-nos ou tente novamente mais
              tarde
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#4B2A66"
            outlined
            exact
            :to="{ name: 'home' }"
            :disabled="loading"
            dark
          >
            Cancelar
          </v-btn>
          <v-btn
            color="#4B2A66"
            class="mr-1"
            @click="register"
            :loading="loading"
            dark
          >
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" multi-line color="blue" rounded="pill"
        ><template v-slot:action="{ attrs }">
          <v-btn color="pink" icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        {{ text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    user: {
      password: "",
      name: "",
      email: "",
      telephone: "",
      city_id: undefined,
      birth_date: new Date().toISOString().substr(0, 10),
      genre: "",
    },
    login: { email: "", password: "" },
    disabledCity: true,
    loadingState: true,
    disabledState: true,
    showPassword: false,
    states: [],
    cities: [],
    menu: false,
    checkbox: false,
    emailalert: false,
    erroralert: false,
    loading: false,
    snackbar: false,
    text: `Cadastro efetuado com sucesso`,
  }),

  methods: {
    register() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.emailalert = false;
        this.erroralert = false;
        this.login.email = this.user.email;
        this.login.password = this.user.password;
        this.$axios
          .post("/user", this.user)
          .then(() => {
            this.snackbar = true;
            this.$axios.put("/login", this.login).finally(() => {
              document.location.reload(true);
            });
            this.$emit("logged");
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 400) {
                this.emailalert = true;
              } else {
                this.erroralert = true;
              }
            } else {
              this.erroralert = true;
            }
          })
          .finally(() => {
            this.loading = false;
            this.$router.replace({
              name: "home",
            });
          });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  computed: {
    birthDateFormatted() {
      return this.formatDate(this.user.birth_date);
    },
  },
  mounted() {
    if (this.$route.params.name && this.$route.params.email) {
      this.user.name = this.$route.params.name;
      this.user.email = this.$route.params.email;
    }
    this.$axios.get("/states").then((response) => {
      this.states = response.data;
      this.loadingState = false;
      this.disabledState = false;
    });
    document.title = `Olhadela - Registro de Usuário`;
  },
  watch: {
    "user.state"(state_id) {
      if (!state_id) {
        this.cities = [];
      } else {
        this.$axios.get("/cities/" + state_id).then((response) => {
          this.cities = response.data;
          this.disabledCity = false;
        });
      }
    },
  },
};
</script>
